// extracted by mini-css-extract-plugin
module.exports = {"container":"CongratilationStep__container___1ZFLx","title":"CongratilationStep__title___3bTUk","image":"CongratilationStep__image___3-pMX"};